export const sharedColors: Record<string, string> = {
  black: '#030303',
  inputHover: '#808d97',
  medGray: '#606060',
  lightGray: '#e5e5e5',
  white: '#ffffff',
  red: '#cd2020',
}
